var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-card',{staticClass:"px-2"},[_c('v-row',[_c('v-col',{staticClass:"py-2",attrs:{"cols":"12","lg":"10"}},[_c('div')]),_c('v-col',{staticClass:"py-2",attrs:{"cols":"12","lg":"2"}},[_vm._t("actions")],2)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }